import React, { useEffect, useRef, useState } from 'react';
import {
	ArticleWRapper,
	BannerWrapper,
	MoArticleWRapper,
	Wrapper,
} from './styled';
import Layout from '../../components/Layout';
import { Link, useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { GetPost, GetPosts, GetTags } from '../../service/blog';
import { useRecoilValue } from 'recoil';
import YouTube from 'react-youtube';
import { seriresAtom, shuffleAtom } from '../../atom/taxonomy';
import {
	SkeletonBanner,
	SkeletonBulletin,
	SkeletonMoBanner,
	SkeletonMoRecent,
	SkeletonRecent,
	SkeletonRightTag,
	SkeletonRightTop,
	SkeletonSingle,
} from '../../components/Skeleton';
import { SkeletonTagWrapper } from '../../components/Skeleton/styled';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import BusinessCard from '../../components/BusinessCard';
import Header from '../../components/Header';
import IOS from '../../components/Popup';
import Android from '../../components/Android';

const Single = (props) => {
	//

	const [agent, setAgent] = useState('');
	useEffect(() => {
		const userAgent = navigator.userAgent;

		const isKakaoTalkInAppBrowser = /KAKAOTALK/i.test(navigator.userAgent);

		if (isKakaoTalkInAppBrowser) {
			console.log('카카오톡 인앱에서 실행 중입니다.');
			if (userAgent.match(/Android/i)) {
				console.log('안드로이드 기기에서 실행 중입니다.');
				// 여기에 필요한 동작을 추가하세요.
				setAgent('android');
			} else if (userAgent.match(/iPhone/i) || userAgent.match(/iPad/i)) {
				console.log('iOS 기기에서 실행 중입니다.');
				setAgent('ios');
				// 여기에 필요한 동작을 추가하세요.
			} else {
				console.log('다른 운영체제에서 실행 중입니다.');
				// 다른 운영체제에서 실행 중인 경우에 대한 처리를 추가하세요.
			}
		} else {
			console.log('not kakao');
			setAgent('');
		}
	}, []);

	const params = useParams();
	const series = useRecoilValue(seriresAtom);
	const shuffle = useRecoilValue(shuffleAtom);

	const { Kakao } = window;

	console.log(window.location);

	const KakaoShare = (e) => {
		Kakao.Link.sendDefault({
			objectType: 'feed',
			buttonTitle: 'KB Blog로 초대합니다.',
			content: {
				title: item?.postTitle,
				imageUrl: `${window.location.origin}/images/logo.png'`,
				link: {
					mobileWebUrl: window.location.href,
					webUrl: window.location.href,
				},
			},
		});
	};

	const [item, setItem] = useState();
	useEffect(() => {
		GetPost({
			ID: params?.ID,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setItem(res.data.body);
				} else {
					setItem(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}, [params?.ID]);

	const [recentPosts, setRecentPosts] = useState([]);
	const [relatedPosts, setRelatedPosts] = useState([]);
	const [total, setTotal] = useState(0);

	useEffect(() => {
		// if (item?.series_ID) {
		GetPosts({
			paged: 1,
			postsPerPage: 3,
			// series: item?.series_ID,
		})
			.then((res) => {
				console.log(res);
				if (res.data.code == 200) {
					setRecentPosts(res.data.body.items);
				} else {
					setRecentPosts(null);
				}
			})
			.catch((err) => {
				console.log(err);
			});
		// }
	}, [item?.series_ID]);

	useEffect(() => {
		if (item) {
			if (item?.series_ID) {
				GetPosts({
					paged: 1,
					postsPerPage: 3,
					series: item?.series_ID,
				})
					.then((res) => {
						console.log(res);
						if (res.data.code == 200) {
							setRelatedPosts(res.data.body.items);
							setTotal(res.data.body.total);
						} else {
							setRelatedPosts(null);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			} else {
				GetPosts({
					paged: 1,
					postsPerPage: 3,
					orderby: 'random',
				})
					.then((res) => {
						console.log(res);
						if (res.data.code == 200) {
							setRelatedPosts(res.data.body.items);
							setTotal(res.data.body.total);
						} else {
							setRelatedPosts(null);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	}, [item?.series]);

	const copy_input = useRef('');
	const CopyLink = (e) => {
		e.preventDefault();
		copy_input.current.select();
		document.execCommand('copy');
		e.target.focus();
		alert('복사완료');
	};

	const [tags, setTags] = useState([]);
	const [s, setS] = useState(false);

	useEffect(() => {
		if (item && item?.series_ID) {
			setS(Math.floor(Math.random() * 10));
			GetTags({
				series: item?.series_ID,
			})
				.then((res) => {
					if (res.data.code == 200) {
						setTags(res.data.body.result);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		} else {
			GetTags({})
				.then((res) => {
					if (res.data.code == 200) {
						setTags(res.data.body.result);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		}
	}, [item?.series_ID]);

	// const metaTag = document.createElement('meta');
	// metaTag.setAttribute('property', 'og:image');
	// metaTag.setAttribute('content', `${item?.thumbnail}`);

	// document.head.appendChild(metaTag);

	// useEffect(() => {
	// 	if (author) {
	// 		setActive(33);
	// 	}
	// }, [params.author]);

	const opts = {
		height: '100%',
		width: '100%',
		playerVars: {
			autoplay: 0,
			mute: 1,
			//   loop: 1,
			//   playlist: 'cAK3r7kPje0',
			controls: 1,
		},
	};

	// const convertYouTubeEmbed = (html) => {
	// 	return html.replace(
	// 		/<div class="wp-block-embed__wrapper">\s*(https:\/\/youtu\.be\/[^\s<]+)\s*<\/div>/g,
	// 		(match, url) => {
	// 			const videoId = url.split('/').pop().split('?')[0];
	// 			return `<iframe width="100%" height="400" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>`;
	// 		}
	// 	);
	// };

	const convertYouTubeEmbed = (html) => {
		return html.replace(
			/(<figure[^>]*wp-block-embed-youtube[^>]*>\s*<div[^>]*wp-block-embed__wrapper[^>]*>)\s*(https:\/\/youtu\.be\/[^\s<]+)\s*(<\/div>\s*<\/figure>)/g,
			(match, startTag, url, endTag) => {
				const videoId = url.split('/').pop().split('?')[0];
				return `
          ${startTag}
          <iframe width="100%" height="400" src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen></iframe>
          ${endTag}
        `;
			}
		);
	};

	const toggle = () => {
		setActive((p) => !p);
	};

	const params_ = new URLSearchParams(window.location.search);
	let author = params_.get('author');
	const [bizcardActive, setActive] = useState(author ? true : false);

	//

	if (agent == 'ios' && author) {
		return <IOS />;
	}

	if (agent == 'android' && author) {
		return <Android />;
	}

	return (
		<>
			<Helmet>
				<title>{item?.postTitle}</title>
				<meta name="description" content={item?.striptPostContent} />
				<meta
					data-react-helmet="true"
					property="og:site_name"
					content="사이트 이름"
				/>
				<meta
					data-react-helmet="true"
					property="og:url"
					content="사이트 주소"
				/>
				<meta
					data-react-helmet="true"
					property="og:image"
					content={item?.thumbnail}
				/>
				<meta
					data-react-helmet="true"
					property="og:description"
					content="설명"
				/>
			</Helmet>
			{author ? <BusinessCard toggle={toggle} active={bizcardActive} /> : null}
			<Layout>
				{/* <meta property="og:image" content={item?.thumbnail} /> */}
				<Wrapper>
					<div className="flex-wrapper">
						<div className="left">
							{item ? (
								<div className="article-wrap">
									<ul className="tag-box">
										{item?.tags?.length
											? item?.tags?.map((i, k) => (
													<Link to={`/tag/${i?.name}`}>
														<li key={k}>#{i?.name}</li>
													</Link>
											  ))
											: null}
									</ul>
									<h2 className="title">{item?.postTitle}</h2>
									<div className="share-box">
										<div className="left">
											<a onClick={KakaoShare}>
												<img src="/images/icon-kakao.svg" alt="" />
											</a>
											<a onClick={CopyLink}>
												<img src="/images/icon-share.svg" alt="" />
											</a>
										</div>
										<div className="right">
											<div className="flex">
												<div className="user-box">
													{!item.authors ? (
														<a href={`/author/${item?.postAuthor}`}>
															<div className="alone">
																<div
																	className="user"
																	style={{
																		backgroundImage: `url(${item?.postAuthorImg})`,
																	}}
																></div>
																<p>{item.postAuthorName}</p>
															</div>
														</a>
													) : (
														<a>
															<div className="people">
																{item.authors.map((i, k) => (
																	<a
																		href={`/author/${item?.postAuthor}`}
																		className="user"
																		style={{
																			backgroundImage: `url(${i?.postAuthorImg})`,
																		}}
																	></a>
																))}
															</div>
														</a>
													)}
												</div>
												{item.series ? (
													<p className="name">
														<img src="/images/icon-lightning.svg" alt="" />
														{item?.series}
													</p>
												) : null}
												<p className="date">{item?.postDate}</p>
											</div>
										</div>
									</div>
									<div className="flex-wrap">
										<div className="left-box">
											<div className="article-box">
												{item.thumbnail ? (
													<img className="article" src={`${item?.thumbnail}`} />
												) : null}
												<div
													className="content"
													dangerouslySetInnerHTML={{
														__html: convertYouTubeEmbed(item?.postContent),
													}}
												></div>
											</div>
											{item.series ? (
												<div className="mo-top-wrap">
													<div className="mo-top-box">
														<div className="imgbox">
															<div
																className="topimg"
																style={{
																	backgroundImage: `url(${shuffle[s]?.moThumbnail})`,
																}}
															></div>
															{/* <div
														style={{
															backgroundImage: `url(${item?.postAuthorImg})`,
														}}
														className="user"
													></div> */}
														</div>
														<div className="text-box">
															<h3>{series[item?.series_ID]?.title}</h3>
															<div className="user-info">
																{/* <p>{item?.postAuthorName}</p> */}
																<span>게시글 {total}</span>
															</div>
														</div>
													</div>
													<div className="mo-content">
														<p>{item?.desc}</p>
													</div>
												</div>
											) : null}

											<div className="list-btn-box">
												<Link
													className="list-btn"
													to={
														item?.series_ID
															? `/blog/series/${item?.series_ID}`
															: '/s'
													}
												>
													<img src="/images/icon-back01.svg" alt="" />
													목록으로
												</Link>
											</div>
										</div>
									</div>
								</div>
							) : (
								<SkeletonSingle />
							)}
						</div>
						<div className="right">
							{item ? (
								<>
									{item.series ? (
										<div className="top-wrap">
											<div className="top-box">
												<div className="imgbox">
													<div
														className="topimg"
														style={{
															backgroundImage: `url(${shuffle[s]?.moThumbnail})`,
														}}
													></div>
												</div>
												<div className="text-box">
													<h3>{item?.series}</h3>
													<p className="total">게시글 {total}개</p>
												</div>
											</div>
											<div className="content">
												<p>{item.desc}</p>
											</div>
										</div>
									) : null}
								</>
							) : (
								<SkeletonRightTop />
							)}

							<div className="bulletin">
								<h3>관련 게시글</h3>
								{relatedPosts?.length ? (
									relatedPosts.map((item, key) => (
										<Link to={`/blog/${item?.ID}`}>
											<div className="bulletin-list" key={key}>
												<div className="photo-box">
													<div
														className="photo"
														style={{
															backgroundImage: `url(${
																item?.thumbnail || '/images/no-image2.png'
															})`,
														}}
													></div>
												</div>
												<div className="text-box">
													<ul>
														{item?.tags?.length
															? item?.tags?.map((i, k) => <li>#{i?.name}</li>)
															: null}
													</ul>
													<h4>{item?.postTitle}</h4>
													<div className="date-box">
														<div className="user-box">
															<div
																style={{
																	backgroundImage: `url(${item?.postAuthorImg})`,
																}}
																className="user"
															></div>
															<p className="name">{item?.postAuthorName}</p>
														</div>
														<span>{item?.postDate}</span>
													</div>
												</div>
											</div>
										</Link>
									))
								) : relatedPosts ? (
									<SkeletonBulletin />
								) : (
									''
								)}
							</div>
							<div className="mo-banner-wrap">
								{item ? (
									<div
										className="mo-banner"
										style={{ backgroundImage: `url(/images/mo-banner.png)` }}
									>
										<p className="title">
											새로운 금융IT 세상을 만들어갈 인재를 모십니다.
										</p>
										<a
											href="https://kbds.career.greetinghr.com/"
											target="_blank"
										>
											<span>
												채용공고 보러가기
												<img src="/images/icon-banner-more.svg" alt="" />
											</span>
										</a>
									</div>
								) : (
									<SkeletonMoBanner />
								)}
								<div className="line"></div>
							</div>
							<MoArticleWRapper>
								<h2>최신 아티클</h2>
								<div className="article-wrap">
									<Swiper
										spaceBetween={10}
										slidesPerView={1.06}
										onSlideChange={() => console.log('slide change')}
										onSwiper={(swiper) => console.log(swiper)}
									>
										{recentPosts?.length ? (
											recentPosts.map((item, key) => (
												<SwiperSlide key={key}>
													<Link to={`/blog/${item?.ID}`}>
														<div className="card">
															<div
																className="banner"
																style={{
																	backgroundImage: `url(${
																		item?.thumbnail || '/images/no-image.png'
																	})`,
																}}
															></div>
															<div className="content-box">
																<ul>
																	{item?.tags?.length
																		? item?.tags?.map((i, k) => (
																				<li>#{i?.name}</li>
																		  ))
																		: null}
																</ul>
																<h2 className="title">{item?.postTitle}</h2>
																<p className="cont">{item?.postContent}</p>
																<div className="flex">
																	<div className="user-box">
																		<div
																			className="user"
																			style={{
																				backgroundImage: `url(${item?.postAuthorImg})`,
																			}}
																		></div>
																	</div>
																	{item.isAuthorName ? null : (
																		<p>{item.postAuthorName}</p>
																	)}
																	<p className="name">
																		<img
																			src="/images/icon-lightning.svg"
																			alt=""
																		/>
																		리드앤라이트
																	</p>
																	<p className="date">{item?.postDate}</p>
																</div>
															</div>
														</div>
													</Link>
												</SwiperSlide>
											))
										) : (
											<SkeletonMoRecent />
										)}
									</Swiper>
								</div>
							</MoArticleWRapper>
							<div className="tag">
								<h3>최근 가장 인기있는 태그</h3>
								{tags?.length ? (
									<ul>
										{tags.map((item, key) => (
											<Link to={`/tag/${item?.value?.name}`}>
												<li key={key}>#{item?.value?.name}</li>
											</Link>
										))}
									</ul>
								) : (
									<SkeletonRightTag />
								)}
							</div>
						</div>
					</div>

					<BannerWrapper>
						{item ? (
							<div
								className="banner"
								style={{ backgroundImage: `url(/images/banner-img02.png)` }}
							>
								<p className="title">
									새로운 금융IT 세상을 만들어갈 인재를 모십니다.
								</p>
								<a href="https://kbds.career.greetinghr.com/" target="_blank">
									<span>
										채용공고 보러가기
										<img src="/images/icon-banner-more.svg" alt="" />
									</span>
								</a>
							</div>
						) : (
							<SkeletonBanner />
						)}
					</BannerWrapper>
					<ArticleWRapper>
						<h2>최신 아티클</h2>
						<div className="article-wrap">
							<Swiper
								spaceBetween={30}
								slidesPerView={3}
								onSlideChange={() => console.log('slide change')}
								onSwiper={(swiper) => console.log(swiper)}
							>
								{recentPosts?.length ? (
									recentPosts.map((item, key) => (
										<SwiperSlide key={key}>
											<Link to={`/blog/${item?.ID}`}>
												<div className="card">
													<div
														className="banner"
														style={{
															backgroundImage: `url(${
																item?.thumbnail || '/images/no-image.png'
															})`,
														}}
													></div>
													<div className="content">
														<ul>
															{item?.tags?.length
																? item?.tags?.map((i, k) => <li>#{i?.name}</li>)
																: null}
														</ul>
														<h2 className="title">{item?.postTitle}</h2>
														<p className="cont">{item?.postContent}</p>
														<div className="flex">
															<div className="user-box">
																<div
																	className="user"
																	style={{
																		backgroundImage: `url(${item?.postAuthorImg})`,
																	}}
																></div>
															</div>
															{item.isAuthorName ? null : (
																<p>{item.postAuthorName}</p>
															)}
															<p className="name">
																<img src="/images/icon-lightning.svg" alt="" />
																리드앤라이트
															</p>
															<p className="date">{item?.postDate}</p>
														</div>
													</div>
												</div>
											</Link>
										</SwiperSlide>
									))
								) : (
									<SkeletonRecent />
								)}
							</Swiper>
						</div>
					</ArticleWRapper>
					<input
						type="text"
						className="input"
						ref={copy_input}
						name="copy_account"
						value={window.location.href}
					/>
				</Wrapper>
			</Layout>
		</>
	);
};

export default Single;
